import { useCallback, useRef } from 'react';

/**
 * Колбэк с ПОСТОЯННОЙ ссылкой, который всегда зовёт свежую версию функции.
 *
 * Нужен для пропсов React.memo-компонентов: обработчик, объявленный в теле
 * страницы, на каждом рендере новый, и memo-строка таблицы из-за него
 * перерисовывалась бы всегда. useCallback с зависимостями тут не спасает —
 * обработчики читают состояние (чёрный список, избранное), и ссылка менялась
 * бы вместе с ним. Здесь ссылка одна на всю жизнь компонента, а вызов уходит в
 * функцию из последнего рендера.
 *
 * Только для обработчиков событий: во время рендера вызывать нельзя (ref
 * обновляется в рендере, и при прерванном рендере значение могло бы опередить
 * экран).
 */
export function useStableCallback<A extends unknown[], R>(fn: (...args: A) => R): (...args: A) => R {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args: A) => ref.current(...args), []);
}
